<template>
<div>
  <div justify="center" >
     <v-card class=" mt-4 mx-auto" max-width="1000" min-width="300">
       
  <v-expand-transition>
    <div class="ma-3">
<div v-if="!feelingscheck(this.feeling)">
<h2> Du har angivigt ditt mående idag. Bra jobbat </h2>

<h2> Tack för din öppenhet! Ha en bra dag! </h2>
  <v-img
            class="mb-3"
            contain
            height="128"
            src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/apple/325/smiling-face-with-smiling-eyes_1f60a.png"
          ></v-img>
</div>

    
      <div v-else>
  <div class="headline text-color-green">Måendekoll </div>
<div class="title">Hej {{this.feeling.name}}, välkommen!</div>
  <div class="headline-3">Här får du klicka i hur du mår och kanske lite annat. Detta hjälper elevhälsan i sitt arbete med att hjälpa dig förbättra ditt mående.</div>

<div class="headline-2">Hur mår du idag på en skala 1-5.</div>
<div>
       <v-btn-toggle
     rounded
          v-model="output.feeling"
          mandatory
        >
<template v-for="f in 5" >
   <v-btn  
   :key="f"
            class="mx-2"
            fab
            dark
            small
           :color="colors[f]"
           
           @click="output.feeling = f;"
          >
          {{f}}
          </v-btn>
</template>
        </v-btn-toggle>

</div>
<v-flex v-for="q in feeling.questions" :key="q">
                   <v-flex v-if="q=='med'|| q=='sch'|| q=='food'">
                   <h1>{{questions.find(   quest => quest.short === q ).Q}} </h1>
    <v-radio-group 
     v-model="output[q]"
    >
      <v-radio
        label="Ja"
        value=1
      ></v-radio>
      <v-radio
        label="Nej"
        value=0
      ></v-radio>
    </v-radio-group>
       </v-flex> 

  <v-flex v-if="q=='sleep'">
                   <h1>{{questions.find(   quest => quest.short === q ).Q}} </h1>
  
     <v-btn-toggle
     rounded
          v-model="output[q]"
          mandatory
        >
        

<template v-for="f in 14" >
   <v-btn  
   :key="f"
            
            class="mx-2"
            fab
            dark
            small
           :color="colors[f]"
           :value="f"
           @click="output.sleep = f;"
          >
          {{f}}
          </v-btn>
</template>

        </v-btn-toggle>

       </v-flex> 

</v-flex>
            <v-btn color="green lighten-1"  :disabled="!output.hasOwnProperty('feeling')"   text dark @click="update();" >
          Skicka in!
        </v-btn>
    </div>
    </div>
  </v-expand-transition>
  <!-- <http://localhost:8080/login#/whistle/N0BJcW1Km0a8GNdwxYX5x9Jxa053 />
  http://localhost:8080/#/whistle/N0BJcW1Km0a8GNdwxYX5x9Jxa053
  http://localhost:8080/whistle#/login
                      
  
   -->
  </v-card>
    </div>
</div>
</template>

<script>
// import classrooms from '../components/classrooms'
import { mapActions, mapGetters } from 'vuex'

export default {
   props: {
    schoolId: String,
    feeling: Object
  },
    data: () => ({
      loaded:false,
      output:{},
      send:false,
      reciever2: [],
      message: "",
      Code:"",
      oldSchoolcode:"",
      Hide: false,
      change:false,
      NewAnswer:{},//{med:"",sch:"", sleep:""},
       questions:[{Q:"Har du tagit dina mediciner?", short:"med", ans:"y"},{Q:"Har du varit eller ska du till skolan idag?", short:"sch", ans:"y"},{Q:"Har du ätit mat i skolan idag?", short:"food", ans:"y"},
        {Q:"Hur många timmar har du sovit i natt?", short:"sleep", ans:"ten"}],
        colors: ["red lighten-1","pink lighten-1","purple lighten-2","blue lighten-1","light-green lighten-1","light-green lighten-3","amber lighten-4","amber lighten-3","amber lighten-2","amber lighten-1","amber darken-1","amber darken-2","amber darken-3","amber darken-4","deep-orange darken-1"]
      // membernameandId: ["Ulla,Kurator","Frank,Skolchef","Roger,Rektor","Lena,SYV"]

  }),

  watch: {
    feeling: function (val) {
     this.Hide=true;
      this.oldSchoolcode=this.Code
        this.change=true;
    },
  },

  methods: {
feelingscheck(feeling)
{
if (feeling.hasOwnProperty('feelings')) {
  let lastDate = new Date( feeling.feelings[feeling.feelings.length - 1].date )
  let Today= new Date()

  //console.log(Today.getDate())
  //console.log(lastDate.getDate())

  if (lastDate.getDate()==Today.getDate()) {
    return false;
  }
//   else
// return true;
}
return true;
},


update(){
  //console.log(this.feeling)
if(!this.feeling.hasOwnProperty('feelings') )
{
  this.feeling.feelings=[];
}
let out= this.output;
  out.date= Date.now();
  this.feeling.feelings.push(out)
  this.updateFeeling(this.feeling)
this.Hide=false;
},

test(cat,input){
this.output[cat] = input;

  //console.log(this.output)
},
    // ...mapActions('ehtmembers', ['logoutEHT','initEHT']),
    // ...mapActions('schools', ['getSchool']),
    ...mapActions('feeling', ['getFeeling','updateFeeling']),
    open(){
      //console.log(this.Hide)
      if (this.Hide==false) {
        //console.log(this.feeling)
      if (this.feeling==null || this.oldSchoolcode!=this.Code) {
        // this.logoutEHT();
      this.getFeeling(this.Code);
       
      }
      else
      this.Hide=!this.Hide;
      }
      else
      this.Hide=!this.Hide;
    },
  
  },
    computed: {
   
    // ...mapGetters('ehtmembers', ['membernameandId']),
    
    // ...mapGetters('feeling', ['feeling']),

  },
  components: {

  }
}
</script>
<style scoped>
 .centered-input >>> input {
      text-align: center;
      color:green;
       font-size: 2em;

    }
  .place{
          width: 50%;
      margin-right: 25%;
      margin-left: 25%;
  }

</style>
